export const defaultSelectedCustomer = () => {
	return {

	}
}

export default {
	customDay:0,
}


// WEBPACK FOOTER //
// ./src/modules/payment-managment/state.js